module.exports = "<div id=refer_inform_uploader> <filesupload params=\"filesize: fileSize, basic: $root.id, groupname: groupname(), callbackDatas: callback,\n    readonly: readOnly, id: id, index: index, enterpriseId: enterpriseId\"></filesupload> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/modalrefer/uploader_information/index.html
// module id = 410
// module chunks = 144